import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';

import LoadingOverlay from "./LoadingOverlay";
export default class Checklistsmaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.checklistsmaster_Id,
          sortable: true,
          cell: (row) => <span>{row.checklistsmaster_Id}</span>,
        },
        { name: "Form Name", selector: (row, i) => row.formName, sortable: true, cell: (row) => <span>{row.formName}</span>, }, { name: "Form Type", selector: (row, i) => row.formType, sortable: true, cell: (row) => <span>{row.formType}</span>, }, { name: "Is Mandatory", selector: (row, i) => row.isMandatory, sortable: true, cell: (row) => <span>{row.isMandatory}</span>, }, { name: "Check List", selector: (row, i) => row.checkList, sortable: true, cell: (row) => <span>{row.checkList}</span>, }, { name: "Table Name", selector: (row, i) => row.tableName, sortable: true, cell: (row) => <span>{row.tableName}</span>, }, { name: "Condition Column", selector: (row, i) => row.conditionColumn, sortable: true, cell: (row) => <span>{row.conditionColumn}</span>, }, { name: "Condition Value", selector: (row, i) => row.conditionValue, sortable: true, cell: (row) => <span>{row.conditionValue}</span>, }, { name: "Dummy One", selector: (row, i) => row.dummyOne, sortable: true, cell: (row) => <span>{row.dummyOne}</span>, }, { name: "Dummy Two", selector: (row, i) => row.dummyTwo, sortable: true, cell: (row) => <span>{row.dummyTwo}</span>, }, { name: "Dummy Three", selector: (row, i) => row.dummyThree, sortable: true, cell: (row) => <span>{row.dummyThree}</span>, }, { name: "Dummy Four", selector: (row, i) => row.dummyFour, sortable: true, cell: (row) => <span>{row.dummyFour}</span>, }, { name: "Dummy Five", selector: (row, i) => row.dummyFive, sortable: true, cell: (row) => <span>{row.dummyFive}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ChecklistsmastereditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      checklistsmaster_Id: "",
      formName: '', formType: '', isMandatory: '', checkList: '', tableName: '', conditionColumn: '', conditionValue: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '',
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true, formName: '', formType: '', isMandatory: '', checkList: '', tableName: '', conditionColumn: '', conditionValue: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false, isEditing: false, formName: '', formType: '', isMandatory: '', checkList: '', tableName: '', conditionColumn: '', conditionValue: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  ChecklistsmastereditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true, checklistsmaster_Id: row.checklistsmaster_Id, formName: row.formName, formType: row.formType, isMandatory: row.isMandatory, checkList: row.checkList, tableName: row.tableName, conditionColumn: row.conditionColumn, conditionValue: row.conditionValue, dummyOne: row.dummyOne, dummyTwo: row.dummyTwo, dummyThree: row.dummyThree, dummyFour: row.dummyFour, dummyFive: row.dummyFive, //***editstate
    });
  }

  ChecklistsmasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + 'C_Checklistsmaster/list', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  }
  ChecklistsmastersubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('formName', this.state.formName);
    formData.append('formType', this.state.formType);
    formData.append('isMandatory', this.state.isMandatory);
    formData.append('checkList', this.state.checkList);
    formData.append('tableName', this.state.tableName);
    formData.append('conditionColumn', this.state.conditionColumn);
    formData.append('conditionValue', this.state.conditionValue);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Checklistsmaster/add', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChecklistsmasterfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ formName: '', formType: '', isMandatory: '', checkList: '', tableName: '', conditionColumn: '', conditionValue: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }
  ChecklistsmasterupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("checklistsmaster_Id", this.state.checklistsmaster_Id);
    formData.append('formName', this.state.formName);
    formData.append('formType', this.state.formType);
    formData.append('isMandatory', this.state.isMandatory);
    formData.append('checkList', this.state.checkList);
    formData.append('tableName', this.state.tableName);
    formData.append('conditionColumn', this.state.conditionColumn);
    formData.append('conditionValue', this.state.conditionValue);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Checklistsmaster/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChecklistsmasterfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }

  componentDidMount() {
    this.ChecklistsmasterfetchHandler();

    //***componentDidMount
  }
  handleformNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ formName: fieldValue });
  }; handleformTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ formType: fieldValue });
  }; handleisMandatoryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ isMandatory: fieldValue });
  }; handlecheckListChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ checkList: fieldValue });
  }; handletableNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tableName: fieldValue });
  }; handleconditionColumnChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ conditionColumn: fieldValue });
  }; handleconditionValueChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ conditionValue: fieldValue });
  }; handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  }; handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  }; handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  }; handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  }; handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append('checklistsmaster_Id', row.checklistsmaster_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Checklistsmaster/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChecklistsmasterfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Checklist Master</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Checklistsmaster</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Form Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleformNameChange} className="form-control" name="formName" value={this.state.formName} required="required" placeholder="Enter Form Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.formName} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Form Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleformTypeChange} className="form-control" name="formType" value={this.state.formType} required="required" placeholder="Enter Form Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.formType} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Is Mandatory</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleisMandatoryChange} className="form-control" name="isMandatory" value={this.state.isMandatory} required="required" placeholder="Enter Is Mandatory" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isMandatory} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Check List</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecheckListChange} className="form-control" name="checkList" value={this.state.checkList} required="required" placeholder="Enter Check List" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.checkList} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletableNameChange} className="form-control" name="tableName" value={this.state.tableName} required="required" placeholder="Enter Table Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tableName} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Condition Column</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleconditionColumnChange} className="form-control" name="conditionColumn" value={this.state.conditionColumn} required="required" placeholder="Enter Condition Column" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conditionColumn} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Condition Value</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleconditionValueChange} className="form-control" name="conditionValue" value={this.state.conditionValue} required="required" placeholder="Enter Condition Value" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conditionValue} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                  </Row><br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.ChecklistsmastersubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Checklistsmaster</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Form Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleformNameChange} className="form-control" name="formName" value={this.state.formName} required="required" placeholder="Enter Form Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.formName} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Form Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleformTypeChange} className="form-control" name="formType" value={this.state.formType} required="required" placeholder="Enter Form Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.formType} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Is Mandatory</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleisMandatoryChange} className="form-control" name="isMandatory" value={this.state.isMandatory} required="required" placeholder="Enter Is Mandatory" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isMandatory} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Check List</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecheckListChange} className="form-control" name="checkList" value={this.state.checkList} required="required" placeholder="Enter Check List" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.checkList} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletableNameChange} className="form-control" name="tableName" value={this.state.tableName} required="required" placeholder="Enter Table Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tableName} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Condition Column</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleconditionColumnChange} className="form-control" name="conditionColumn" value={this.state.conditionColumn} required="required" placeholder="Enter Condition Column" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conditionColumn} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Condition Value</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleconditionValueChange} className="form-control" name="conditionValue" value={this.state.conditionValue} required="required" placeholder="Enter Condition Value" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conditionValue} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                    </Row><br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.ChecklistsmasterupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
